module.exports = __webpack_public_path__ + "img/img1.60ba3a18.png";